export interface ReviewConfigEditorListenerHandler {
    handleReviewSettingsModalClick(event: Event): void;
    handleReviewSettingsSave(event: Event): Promise<void> | void;
    handleReviewSettingsAdd(event: Event): Promise<void> | void;
    handleReviewSettingsClose(event: Event): void;
    onReviewPanelInput(event: Event): void;
    onReviewPanelChange(event: Event): void;
    onReviewPanelClick(event: Event): void;
}

export interface ReviewConfigEditorListenerElements {
    reviewSettingsModalEl: HTMLElement;
    reviewSettingsPanelEl: HTMLElement;
    reviewSettingsSaveBtnEl: HTMLElement;
    reviewSettingsAddBtnEl: HTMLElement;
    reviewSettingsCloseBtnEls: HTMLElement[];
}

export class ReviewConfigEditorListener {
    public handler: ReviewConfigEditorListenerHandler;
    public elements: ReviewConfigEditorListenerElements;

    /**
     * @param {{
     *   handleReviewSettingsModalClick(event: Event): void,
     *   handleReviewSettingsSave(event: Event): Promise<void>|void,
     *   handleReviewSettingsAdd(event: Event): Promise<void>|void,
     *   handleReviewSettingsClose(event: Event): void,
     *   onReviewPanelInput(event: Event): void,
     *   onReviewPanelChange(event: Event): void,
     *   onReviewPanelClick(event: Event): void,
     * }} handler
     * @param {{
     *   reviewSettingsModalEl: HTMLElement,
     *   reviewSettingsPanelEl: HTMLElement,
     *   reviewSettingsSaveBtnEl: HTMLElement,
     *   reviewSettingsAddBtnEl: HTMLElement,
     *   reviewSettingsCloseBtnEls: HTMLElement[]
     * }} elements
     */
    public constructor(handler: ReviewConfigEditorListenerHandler, elements: ReviewConfigEditorListenerElements) {
        this.handler = handler;
        this.elements = elements;
    }

    public register(): void {
        const {
            reviewSettingsModalEl,
            reviewSettingsPanelEl,
            reviewSettingsSaveBtnEl,
            reviewSettingsAddBtnEl,
            reviewSettingsCloseBtnEls,
        } = this.elements;

        reviewSettingsModalEl.addEventListener("click", (event) => this.handler.handleReviewSettingsModalClick(event));
        reviewSettingsSaveBtnEl.addEventListener("click", (event) => this.handler.handleReviewSettingsSave(event));
        reviewSettingsAddBtnEl.addEventListener("click", (event) => this.handler.handleReviewSettingsAdd(event));
        reviewSettingsCloseBtnEls.forEach((el) => {
            el.addEventListener("click", (event) => this.handler.handleReviewSettingsClose(event));
        });
        reviewSettingsPanelEl.addEventListener("input", (event) => this.handler.onReviewPanelInput(event));
        reviewSettingsPanelEl.addEventListener("change", (event) => this.handler.onReviewPanelChange(event));
        reviewSettingsPanelEl.addEventListener("click", (event) => this.handler.onReviewPanelClick(event));
    }
}
